import React, { useState, useEffect, useCallback } from 'react';
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Media,
    Collapse,
    Form,
    Input,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../components/Common/LoadingModal"
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import '../../components/Common/Common.css';
import { useDispatch, useSelector } from "react-redux";
import PeriodBtn from "../../components/Filter/PeriodBtn";

import {
    getMemberStatisticsList,
    setAdmMemberStatisticsError,
    setAdmMemberStatisticsLoading,
    setAdmMemberStatisticsSuccess,

    getMemberActivityList,
    getAddedContactsList,
    getDeletedContactsList,
    getStarredEntitiesList,
    getHiddenEntitiesList
} from "../../store/actions";
import { filter } from 'lodash';
import classnames from "classnames"
import MemberStatistics from './MemberStatistics';
import MemberActivity from './MemberActivity';

const AdmMemberStatistics = props => {
    const dispatch = useDispatch();

    // Form open toggle
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    // Tab
    const [tabItems, setTabItems] = useState(["Statistics", "Activity"]);
    const [activeTab, setActiveTab] = useState("Statistics");
    const toggleActiveTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    const { loading, error, success, noticeStr, totalPage, statisticsList, statFromDate, statToDate, statUpdatedDate } = useSelector(state => ({
        loading: state.admMemberStatistics.loading,
        error: state.admMemberStatistics.error,
        success: state.admMemberStatistics.success,
        noticeStr: state.admMemberStatistics.noticeStr,
        totalPage: state.admMemberStatistics.totalPage,
        statFromDate: state.admMemberStatistics.fromDate,
        statToDate: state.admMemberStatistics.toDate,
        statUpdatedDate: state.admMemberStatistics.statUpdatedDate,
        totalPage: state.admMemberStatistics.totalPage,
        statisticsList: state.admMemberStatistics.statisticsList,
    }))

    const filterValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            submitType: "view",

            perPage: 20,
            curPage: 1,
            datePeriod: "",
            fromDate: "",
            toDate: "",
            member: "",
            weYn: "Both",
            accountTypes: ['PR', 'PT', 'FR'],
            sort: "SSD",
            salesOwner: "",


            activityMember: "",
            contact: "",
            activity: null,
            datePeriodAct: "",
            fromDateAct: "",
            toDateAct: "",
            perPageAct: 20,
            curPageAct: 1,
        },

        onSubmit: (values) => {

            if (activeTab == "Statistics") {
                const filterParam = {
                    limit: values.perPage,
                    curPage: values.curPage,
                    member: values.member,
                    weYn: values.weYn,
                    fromDate: values.fromDate ? values.fromDate.replace(/-/g, "") : "",
                    toDate: values.toDate ? values.toDate.replace(/-/g, "") : "",
                    accountTypes: values.accountTypes,
                    salesOwner: values.salesOwner,
                    sortType: values.sort
                };

                if (!filterParam.accountTypes || !Array.isArray(filterParam.accountTypes) || filterParam.accountTypes.length == 0) {
                    dispatch(setAdmMemberStatisticsError("Account type is required!"))
                } else {
                    let submitType = values["submitType"];

                    if (submitType === "view") {
                        console.log(filterParam)
                        dispatch(getMemberStatisticsList(filterParam));
                    }
                }
            } else if (activeTab == "Activity") {
                let submitType = values["submitType"];
                if (submitType === "view") {
                    const filterParam = {
                        member: values.activityMember.trim(),
                        emailAddress: values.contact.trim(),
                        fromDate: values.fromDateAct ? values.fromDateAct + " 00:00:00" : "",
                        toDate: values.toDateAct ? values.toDateAct + " 23:59:59" : "",
                        limit: values.perPageAct,
                        curPage: values.curPageAct,
                    };
    
                    if (!filterParam.member) {
                        dispatch(setAdmMemberStatisticsError("Member is required!"))
                    } else if (filterParam.fromDate && !filterParam.toDate) {
                        dispatch(setAdmMemberStatisticsError("To date is required!"))
                    } else if (!filterParam.fromDate && filterParam.toDate) {
                        dispatch(setAdmMemberStatisticsError("From date is required!"))
                    } else {
                        console.log(filterParam)
                        dispatch(getMemberActivityList(filterParam));
                    }
                } else if (submitType === "viewAddedContactLog") {
                        console.log(filterValidation.values.activity)
                        dispatch(getAddedContactsList(filterValidation.values.activity));
                } else if (submitType === "viewDeletedContactLog") {
                        console.log(filterValidation.values.activity)
                        dispatch(getDeletedContactsList(filterValidation.values.activity));
                } else if (submitType === "viewEntitiesStarLog") {
                        console.log(filterValidation.values.activity)
                        dispatch(getStarredEntitiesList(filterValidation.values.activity));
                } else if (submitType === "viewEntitiesHideLog") {
                        console.log(filterValidation.values.activity)
                        dispatch(getHiddenEntitiesList(filterValidation.values.activity));
                } 
            }

        }
    })

    return (
        <React.Fragment>
            <Form onSubmit={() => { }}>
                <div className="page-content">
                    <div className="container-fluid">
                        <Nav tabs className="col-md-5 nav-tabs-custom nav-justified">
                            {
                                tabItems.map(item => {
                                    return (
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({
                                                    active: activeTab === item,
                                                })}
                                                onClick={() => {
                                                    toggleActiveTab(item)
                                                }}
                                            >
                                                <span>
                                                    {item} &nbsp;&nbsp;
                                                </span>
                                            </NavLink>
                                        </NavItem>
                                    )
                                })
                            }
                        </Nav>

                        <TabContent
                            activeTab={activeTab}
                            className="text-muted"
                        >
                            <MemberStatistics
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={"Statistics"}
                                filterValidation={filterValidation}
                            />
                            <MemberActivity
                                toggle={toggle}
                                isOpen={isOpen}
                                activeTab={activeTab}
                                tabId={"Activity"}
                                filterValidation={filterValidation}
                            />
                        </TabContent>
                        

                        {
                            loading ?
                                <LoadingModal
                                    loading={loading}
                                    setLoading={() => {
                                        dispatch(setAdmMemberStatisticsLoading(!loading));
                                    }}
                                ></LoadingModal>
                                : null
                        }

                        {
                            success ?
                                <SweetAlert
                                    title={success}
                                    timeout={2000}
                                    showCloseButton={false}
                                    showConfirm={false}
                                    success
                                    onConfirm={() => {
                                        dispatch(setAdmMemberStatisticsSuccess(""));
                                    }}
                                ></SweetAlert>
                                : null
                        }

                        {
                            error ?
                                <SweetAlert
                                    warning
                                    title={error}
                                    onConfirm={() => {
                                        dispatch(setAdmMemberStatisticsError(""));
                                    }}
                                ></SweetAlert>
                                : null
                        }
                    </div>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default AdmMemberStatistics;